import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import { Information } from '../../../src/components/Information';
import { PostView } from '../../../src/components/PostView';
import { ServiceProspectConfirmation } from '../../../src/components/ServiceProspectConfirmation';
import { PostViewTopBar } from '../../../src/components/TopBar';
import { Button } from '../../../src/subkit-ui';
import { getFirstImageFromPost, getQuery, removeHTMLTags, truncate } from '../../../src/utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var PostViewPage = function PostViewPage(_ref) {
  var _props$post;

  var props = _extends({}, _ref);

  var router = useRouter();
  var query = router.query;
  var providerSlug = getQuery(query.providerSlug);
  var post = props.post,
      service = props.service,
      currentUser = props.currentUser;

  var viewProfile = function viewProfile() {
    router.push("/".concat(providerSlug));
  };

  if (!post) {
    return /*#__PURE__*/_jsxs("div", {
      className: "h-fill flex flex-column items-center justify-center h1 p2",
      children: [/*#__PURE__*/_jsx(Information, {
        heading: "Post Missing"
      }), /*#__PURE__*/_jsx(Button, {
        text: "Go back to posts view",
        classes: "mt-3",
        onClick: router.back
      })]
    });
  }

  var postImage = getFirstImageFromPost(post.body) || service.bgImageUrl;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "".concat(post.title, " by ").concat(service.name)
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: truncate(removeHTMLTags(post.body), 200)
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:site_name",
        content: "Subkit"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:title",
        content: "".concat(post.title, " by ").concat(service.name)
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:description",
        content: truncate(removeHTMLTags(post.body), 200)
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:url",
        content: "http://subkit.com/".concat(providerSlug, "/posts/").concat(post.slug)
      }), /*#__PURE__*/_jsx("meta", {
        property: "og:image",
        content: postImage
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:card",
        content: "summary_large_image"
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:title",
        content: "".concat(post.title, " by ").concat(service.name)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:description",
        content: truncate(removeHTMLTags(post.body), 200)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:image:alt",
        content: truncate(removeHTMLTags(post.body), 200)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:url",
        content: "http://subkit.com/".concat(providerSlug, "/posts/").concat(post.slug)
      }), /*#__PURE__*/_jsx("meta", {
        property: "twitter:image",
        content: postImage
      }), !((_props$post = props.post) !== null && _props$post !== void 0 && _props$post.grantorType) && /*#__PURE__*/_jsx("meta", {
        name: "robots",
        content: "noindex noarchive"
      })]
    }), props.serviceProspect && !props.serviceProspectVerificationSent ? /*#__PURE__*/_jsx(ServiceProspectConfirmation, {
      providerService: props.service,
      provider: props.provider
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PostViewTopBar, {
        provider: props.provider,
        service: props.service,
        viewProfile: viewProfile
      }), /*#__PURE__*/_jsx(PostView, {
        post: props.post,
        provider: props.provider,
        service: props.service,
        currentUser: currentUser
      })]
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$users;

  return {
    isLoggedIn: !!((_state$auth$users = state.auth.users) !== null && _state$auth$users !== void 0 && _state$auth$users.current),
    serviceProspect: state.provider.serviceProspects.current,
    serviceProspectVerificationSent: state.provider.serviceProspectVerificationSent
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

export var __N_SSP = true;
export default connect(mapStateToProps, mapDispatchToProps)(PostViewPage);